<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  vue-treeselect vue-treeselect--single vue-treeselect--searchable vue-treeselect--open-below
      /* mini */
    .vue-treeselect[size="mini"] {
      height: 26px !important;
    }
    .vue-treeselect[size="mini"] .vue-treeselect__control {
      height: 26px !important;
    }
    .vue-treeselect[size="mini"] .vue-treeselect__control .vue-treeselect__value-container {
      height: 26px !important;
      display: block !important;
    }
    .vue-treeselect[size="mini"]
      .vue-treeselect__control
      .vue-treeselect__value-container
      .vue-treeselect__placeholder {
      line-height: 26px !important;
      font-size: 12px !important;
    }
    .vue-treeselect[size="mini"]
      .vue-treeselect__control
      .vue-treeselect__value-container
      .vue-treeselect__single-value {
      line-height: 26px !important;
      font-size: 12px !important;
    }

    /* small */
    .vue-treeselect[size="small"] .vue-treeselect__control {
      height: 30px !important;
    }
    .vue-treeselect[size="small"] .vue-treeselect__control .vue-treeselect__value-container {
      height: 30px !important;
      display: block !important;
    }
    .vue-treeselect[size="small"]
      .vue-treeselect__control
      .vue-treeselect__value-container
      .vue-treeselect__placeholder {
      line-height: 30px !important;
      font-size: 14px !important;
    }
    .vue-treeselect[size="small"]
      .vue-treeselect__control
      .vue-treeselect__value-container
      .vue-treeselect__single-value {
      line-height: 30px !important;
      font-size: 14px !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue